var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongHoutai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 9,
    rx: 0.5,
    stroke: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5L6 8l2-2 1.5 1.5 2-2",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11v3",
    stroke: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H4",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjEyIiBoZWlnaHQ9IjkiIHJ4PSIwLjUiIHN0cm9rZT0iIzNGNDY1QyIvPgo8cGF0aCBkPSJNNC41IDYuNUw2IDhMOCA2TDkuNSA3LjVMMTEuNSA1LjUiIHN0cm9rZT0iIzNGNDY1QyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDExVjE0IiBzdHJva2U9IiMzRjQ2NUMiLz4KPHBhdGggZD0iTTEyIDE0TDQgMTQiIHN0cm9rZT0iIzNGNDY1QyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgTongyongHoutai as ReactComponent };